// extracted by mini-css-extract-plugin
export default {"iconItem":"icon_iconItem__oaxGU","iconWrapper":"icon_iconWrapper__iJntj","label":"icon_label__iqrSS"};